import React, { useEffect } from 'react';
import { PageHero } from '../components/page/PageHero';
import { IncludedList } from '../components/page/IncludedList';
import { WhyLawyerLed } from '../components/page/WhyLawyerLed';
import { Process } from '../components/home/Process';
import { FeeTransparency } from '../components/page/FeeTransparency';
import { MiniFAQ } from '../components/page/MiniFAQ';
import { FinalCTA } from '../components/home/FinalCTA';
const INCLUDED = [{
  title: 'Contract of sale preparation',
  body: 'Your contract of sale is prepared correctly so the property can go to market without avoidable delay.'
}, {
  title: 'Section 32 vendor statement',
  body: 'The vendor statement is prepared with the prescribed disclosures Victorian sellers are required to provide.'
}, {
  title: 'Buyer enquiry management',
  body: 'Questions from buyers and their representatives are handled so the sale keeps moving.'
}, {
  title: 'Auction and private sale',
  body: 'Support whether you are selling by auction or private treaty, including contract readiness for auction day.'
}, {
  title: 'Settlement coordination',
  body: 'Documents, adjustments and settlement are coordinated through to completion.'
}, {
  title: 'One point of contact',
  body: 'You deal with the team handling your file directly throughout the sale.'
}];
const FAQS = [{
  q: 'What is a Section 32 vendor statement?',
  a: 'It is a disclosure document a Victorian seller provides to a buyer before the buyer signs the contract. It contains prescribed information about the property and should be considered together with the contract.'
}, {
  q: 'When should I get the contract prepared?',
  a: 'Before you go to market. Having the contract and vendor statement ready means buyers can act when they are interested, rather than waiting on paperwork.'
}, {
  q: 'What does it cost?',
  a: 'You receive a clear scope and fee before any work begins. Send the details of your sale for a quote.'
}];
export function SellingProperty() {
  useEffect(() => {
    document.title = 'Selling Property in Victoria | L.A Property Law';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-702">
      <PageHero eyebrow="selling property" title="Go to market with the paperwork done right." intro="Prepare the contract and vendor statement correctly, respond to buyer enquiries and keep the transaction moving toward settlement." imageSrc="https://images.unsplash.com/photo-1592595896551-12b371d546d5?auto=format&fit=crop&w=1200&q=80" imageAlt="Victorian terrace home in Carlton, Melbourne" primaryLabel="Get a free quote" primaryAction="quote" data-id="element-703" />
      <IncludedList eyebrow="what is included" heading="Seller support from listing to settlement." intro="Your contract and vendor statement prepared properly, then coordinated management through to settlement." items={INCLUDED} data-id="element-704" />
      <WhyLawyerLed data-id="element-705" />
      <Process data-id="element-706" />
      <FeeTransparency variant="background" data-id="element-707" />
      <MiniFAQ items={FAQS} data-id="element-708" />
      <FinalCTA data-id="element-709" />
    </main>;
}